import { rules } from './rules';

export const validateParentLogin = (formData) => {
  const errors = {};

  const emailError = rules.email(formData.email);
  if (emailError) errors.email = emailError;

  const passwordError = rules.password(formData.password);
  if (passwordError) errors.password = passwordError;

  return errors;
};

export const validateParentRegister = (formData) => {
  const errors = {};

  const firstNameError = rules.firstName(formData.first_name);
  if (firstNameError) errors.first_name = firstNameError;

  const lastNameError = rules.lastName(formData.last_name);
  if (lastNameError) errors.last_name = lastNameError;

  const emailError = rules.email(formData.email);
  if (emailError) errors.email = emailError;

  const phoneError = rules.phone(formData.phone);
  if (phoneError) errors.phone = phoneError;

  const passwordError = rules.password(formData.password);
  if (passwordError) errors.password = passwordError;

  const confirmPasswordError = rules.passwordConfirmation(
    formData.confirm_password,
    formData.password,
  );
  if (confirmPasswordError) errors.confirm_password = confirmPasswordError;

  return errors;
};
